import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface LegalModalsProps {
  showPrivacy: boolean;
  showTerms: boolean;
  onClosePrivacy: () => void;
  onCloseTerms: () => void;
}
export function LegalModals({
  showPrivacy,
  showTerms,
  onClosePrivacy,
  onCloseTerms
}: LegalModalsProps) {
  return <>
      {/* ── POLÍTICA DE PRIVACIDAD ── */}
      <AnimatePresence data-id="element-116">
        {showPrivacy && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/85 z-[200] flex items-center justify-center p-5" onClick={onClosePrivacy} data-id="element-117">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} className="bg-[var(--card)] border border-[var(--border)] rounded-2xl p-7 max-w-[540px] w-full max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-118">
              <h2 className="text-xl font-bold mb-1" data-id="element-119">Política de Privacidad</h2>
              <p className="text-[var(--muted)] text-xs mb-5" data-id="element-120">
                Última actualización: 14 de abril de 2025
              </p>

              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-121">
                Esta Política de Privacidad describe cómo{' '}
                <strong className="text-white" data-id="element-122">Código Rojo</strong> ("nosotros",
                "nuestro") recopila, usa y protege la información personal que
                proporcionas al realizar una compra a través de nuestra tienda
                en línea alojada en Shopify.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-123">
                1. Información que recopilamos
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-2" data-id="element-124">
                Cuando realizas una compra, recopilamos únicamente la
                información necesaria para procesar tu pedido y entregarte el
                producto:
              </p>
              <ul className="text-[var(--muted)] text-sm leading-relaxed mb-4 list-disc pl-5 space-y-1" data-id="element-125">
                <li data-id="element-126">Nombre completo</li>
                <li data-id="element-127">Dirección de correo electrónico</li>
                <li data-id="element-128">Dirección IP (recopilada automáticamente)</li>
                <li data-id="element-129">Información del navegador (recopilada automáticamente)</li>
              </ul>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-130">
                <strong className="text-white" data-id="element-131">No recopilamos</strong> datos de
                tarjetas de crédito ni información financiera. Todos los pagos
                son procesados de forma segura por{' '}
                <strong className="text-white" data-id="element-132">Shopify Payments</strong>, que
                cumple con los estándares PCI DSS Nivel 1.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-133">
                2. Cómo usamos tu información
              </h3>
              <ul className="text-[var(--muted)] text-sm leading-relaxed mb-4 list-disc pl-5 space-y-1" data-id="element-134">
                <li data-id="element-135">Procesar y confirmar tu compra</li>
                <li data-id="element-136">Enviarte el enlace de descarga del producto digital</li>
                <li data-id="element-137">Comunicarnos contigo en caso de problemas con tu pedido</li>
                <li data-id="element-138">
                  Procesar solicitudes de reembolso dentro del período de
                  garantía
                </li>
              </ul>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-139">
                <strong className="text-white" data-id="element-140">
                  No enviamos correos promocionales no solicitados.
                </strong>{' '}
                Tu correo electrónico solo se usa para la entrega del producto y
                comunicaciones directamente relacionadas con tu compra.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-141">
                3. Compartición de datos con terceros
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-2" data-id="element-142">
                <strong className="text-white" data-id="element-143">
                  No vendemos, alquilamos ni compartimos
                </strong>{' '}
                tu información personal con terceros para fines de marketing.
                Solo compartimos datos con los siguientes proveedores de
                servicios esenciales:
              </p>
              <ul className="text-[var(--muted)] text-sm leading-relaxed mb-4 list-disc pl-5 space-y-1" data-id="element-144">
                <li data-id="element-145">
                  <strong className="text-white" data-id="element-146">Shopify Inc.</strong> —
                  Plataforma de comercio electrónico y procesamiento de pagos
                </li>
                <li data-id="element-147">
                  <strong className="text-white" data-id="element-148">
                    Proveedor de correo electrónico
                  </strong>{' '}
                  — Para la entrega del producto digital
                </li>
              </ul>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-149">
                Estos proveedores solo acceden a la información estrictamente
                necesaria para cumplir con su función y están obligados a
                proteger tus datos.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-150">
                4. Retención de datos
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-151">
                Conservamos tu información de compra durante el tiempo necesario
                para cumplir con nuestras obligaciones legales y fiscales.
                Puedes solicitar la eliminación de tus datos personales en
                cualquier momento escribiendo a{' '}
                <a href="mailto:soporte.codigorojo@gmail.com" className="text-[var(--red2)] underline" data-id="element-152">
                  soporte.codigorojo@gmail.com
                </a>
                .
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-153">
                5. Seguridad
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-154">
                Utilizamos medidas de seguridad estándar de la industria para
                proteger tu información personal. Nuestra tienda opera sobre la
                infraestructura segura de Shopify con cifrado SSL/TLS en todas
                las transacciones.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-155">
                6. Cookies
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-156">
                Nuestro sitio utiliza cookies esenciales proporcionadas por
                Shopify para el funcionamiento básico de la tienda (carrito de
                compras, sesión). No utilizamos cookies de seguimiento
                publicitario de terceros.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-157">
                7. Tus derechos
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-2" data-id="element-158">
                Dependiendo de tu ubicación, puedes tener derecho a:
              </p>
              <ul className="text-[var(--muted)] text-sm leading-relaxed mb-4 list-disc pl-5 space-y-1" data-id="element-159">
                <li data-id="element-160">Acceder a los datos personales que tenemos sobre ti</li>
                <li data-id="element-161">Solicitar la corrección de datos inexactos</li>
                <li data-id="element-162">Solicitar la eliminación de tus datos personales</li>
                <li data-id="element-163">Oponerte al procesamiento de tus datos</li>
              </ul>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-164">
                Si resides en California, tienes derechos adicionales bajo la
                CCPA. Para ejercer cualquiera de estos derechos, contáctanos en{' '}
                <a href="mailto:soporte.codigorojo@gmail.com" className="text-[var(--red2)] underline" data-id="element-165">
                  soporte.codigorojo@gmail.com
                </a>
                .
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-166">
                8. Menores de edad
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-167">
                Nuestro producto está dirigido a personas mayores de 18 años. No
                recopilamos intencionalmente información de menores de edad.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-168">
                9. Cambios a esta política
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-169">
                Nos reservamos el derecho de actualizar esta Política de
                Privacidad en cualquier momento. Los cambios serán publicados en
                esta misma página con la fecha de actualización correspondiente.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-170">
                10. Contacto
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-171">
                Si tienes preguntas sobre esta Política de Privacidad o deseas
                ejercer tus derechos, escríbenos a:
                <br data-id="element-172" />
                <a href="mailto:soporte.codigorojo@gmail.com" className="text-[var(--red2)] underline" data-id="element-173">
                  soporte.codigorojo@gmail.com
                </a>
              </p>

              <button onClick={onClosePrivacy} className="bg-[var(--red)] text-white border-none rounded-lg px-5 py-2.5 font-bold cursor-pointer mt-2 hover:bg-[#a82040] transition-colors" data-id="element-174">
                Cerrar
              </button>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* ── TÉRMINOS Y CONDICIONES ── */}
      <AnimatePresence data-id="element-175">
        {showTerms && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/85 z-[200] flex items-center justify-center p-5" onClick={onCloseTerms} data-id="element-176">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} className="bg-[var(--card)] border border-[var(--border)] rounded-2xl p-7 max-w-[540px] w-full max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-177">
              <h2 className="text-xl font-bold mb-1" data-id="element-178">Términos y Condiciones</h2>
              <p className="text-[var(--muted)] text-xs mb-5" data-id="element-179">
                Última actualización: 14 de abril de 2025
              </p>

              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-180">
                Al realizar una compra en{' '}
                <strong className="text-white" data-id="element-181">Código Rojo</strong> ("nosotros",
                "nuestro"), aceptas los siguientes Términos y Condiciones. Por
                favor, léelos cuidadosamente antes de completar tu compra.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-182">
                1. Descripción del producto
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-183">
                Código Rojo es un{' '}
                <strong className="text-white" data-id="element-184">
                  producto digital descargable
                </strong>{' '}
                de carácter educativo e informativo. Consiste en una guía en
                formato digital que incluye un sistema de evaluación de 20
                puntos, fichas de evaluación, material complementario y bonos
                adicionales. El precio es de{' '}
                <strong className="text-white" data-id="element-185">$17 USD, pago único</strong>. No
                se trata de una suscripción y no se realizarán cargos
                recurrentes.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-186">
                2. Entrega del producto
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-187">
                Tras completar el pago exitosamente a través de Shopify
                Payments, recibirás un correo electrónico con el enlace de
                descarga de todos los materiales digitales. La entrega es{' '}
                <strong className="text-white" data-id="element-188">inmediata y automática</strong>.
                Si no recibes el correo dentro de los primeros 15 minutos,
                revisa tu carpeta de spam o escríbenos a{' '}
                <a href="mailto:soporte.codigorojo@gmail.com" className="text-[var(--red2)] underline" data-id="element-189">
                  soporte.codigorojo@gmail.com
                </a>
                .
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-190">
                3. Licencia de uso
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-2" data-id="element-191">
                Al adquirir Código Rojo, se te otorga una{' '}
                <strong className="text-white" data-id="element-192">
                  licencia personal, intransferible y no exclusiva
                </strong>{' '}
                para usar el contenido. Esto significa que:
              </p>
              <ul className="text-[var(--muted)] text-sm leading-relaxed mb-4 list-disc pl-5 space-y-1" data-id="element-193">
                <li data-id="element-194">El contenido es exclusivamente para tu uso personal</li>
                <li data-id="element-195">
                  No puedes reproducir, distribuir, revender ni compartir el
                  material con terceros
                </li>
                <li data-id="element-196">
                  No puedes publicar el contenido en redes sociales, blogs,
                  foros u otros medios públicos
                </li>
                <li data-id="element-197">
                  No puedes crear productos derivados basados en el contenido
                </li>
              </ul>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-198">
                La violación de estos términos resultará en la revocación
                inmediata de tu licencia sin derecho a reembolso.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-199">
                4. Política de reembolso — Garantía de 30 días
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-2" data-id="element-200">
                Ofrecemos una{' '}
                <strong className="text-white" data-id="element-201">
                  garantía de devolución total de 30 días
                </strong>{' '}
                a partir de la fecha de compra. Si no estás satisfecha con el
                producto, puedes solicitar el reembolso completo del 100% de tu
                dinero.
              </p>
              <ul className="text-[var(--muted)] text-sm leading-relaxed mb-4 list-disc pl-5 space-y-1" data-id="element-202">
                <li data-id="element-203">
                  El reembolso se solicita enviando un correo a{' '}
                  <a href="mailto:soporte.codigorojo@gmail.com" className="text-[var(--red2)] underline" data-id="element-204">
                    soporte.codigorojo@gmail.com
                  </a>
                </li>
                <li data-id="element-205">
                  No se requieren formularios complicados ni justificaciones
                </li>
                <li data-id="element-206">
                  El reembolso se procesará a través de Shopify Payments al
                  mismo método de pago original
                </li>
                <li data-id="element-207">
                  El plazo de procesamiento es de 5 a 10 días hábiles
                  dependiendo de tu banco
                </li>
                <li data-id="element-208">
                  Después de los 30 días, no se aceptarán solicitudes de
                  reembolso
                </li>
              </ul>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-209">
                5. Procesamiento de pagos
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-210">
                Todos los pagos son procesados de forma segura a través de{' '}
                <strong className="text-white" data-id="element-211">Shopify Payments</strong>.
                Aceptamos las principales tarjetas de crédito y débito. No
                almacenamos ni tenemos acceso a los datos de tu tarjeta. El
                cargo aparecerá en tu estado de cuenta como una transacción de
                Shopify.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-212">
                6. Propiedad intelectual
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-213">
                Todo el contenido de Código Rojo — incluyendo textos, diseños,
                gráficos, metodologías y materiales complementarios — es
                propiedad exclusiva de Código Rojo y está protegido por las
                leyes de propiedad intelectual de los Estados Unidos. Todos los
                derechos están reservados.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-214">
                7. Limitación de responsabilidad
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-215">
                Código Rojo es una herramienta educativa e informativa diseñada
                para apoyar la toma de decisiones personales.{' '}
                <strong className="text-white" data-id="element-216">
                  No constituye asesoría psicológica, terapéutica ni profesional
                  de ningún tipo.
                </strong>{' '}
                Los resultados individuales pueden variar. No nos hacemos
                responsables de las decisiones personales que tomes basándote en
                el contenido del producto.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-217">
                8. Elegibilidad
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-218">
                Para adquirir este producto debes ser mayor de 18 años y tener
                la capacidad legal para realizar transacciones en línea.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-219">
                9. Modificaciones
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-220">
                Nos reservamos el derecho de modificar estos Términos y
                Condiciones en cualquier momento. Los cambios serán publicados
                en esta misma página. El uso continuado del producto después de
                cualquier modificación constituye la aceptación de los nuevos
                términos.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-221">
                10. Ley aplicable
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-222">
                Estos Términos y Condiciones se rigen por las leyes de los
                Estados Unidos de América. Cualquier disputa será resuelta bajo
                la jurisdicción de los tribunales competentes en los Estados
                Unidos.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-223">
                11. Contacto
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-224">
                Para cualquier pregunta, solicitud de reembolso o consulta
                relacionada con estos términos, escríbenos a:
                <br data-id="element-225" />
                <a href="mailto:soporte.codigorojo@gmail.com" className="text-[var(--red2)] underline" data-id="element-226">
                  soporte.codigorojo@gmail.com
                </a>
              </p>

              <button onClick={onCloseTerms} className="bg-[var(--red)] text-white border-none rounded-lg px-5 py-2.5 font-bold cursor-pointer mt-2 hover:bg-[#a82040] transition-colors" data-id="element-227">
                Cerrar
              </button>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}